import AdminLayout from "components/layouts/AdminLayout";
import Tenders from "components/tenders/Tenders";

function TendersPage(props: any) {

    return (
        <AdminLayout>
            <Tenders props={props} />
        </AdminLayout>
    );
}

export default TendersPage;